import React from 'react';
import styled, { css } from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { randomInt } from 'util/Random';
import { Markdown } from '../Markdown/Markdown';


export interface HtmlComponentProps {
  className?: string
  srOnly?: boolean;
}


export interface UFCTextProps {
  srOnly?: boolean;
  as?: any;
}

const headerStyles = css`
  font-weight: 400;

  color: ${props => props.theme.texto.enfase_alta};
  margin: 0;
`;

const StyledH2 = styled.h2`
  ${headerStyles};
  font-size: 1.45rem;
  letter-spacing: -0.01em;
`;

const StyledH3 = styled.h3`
  ${headerStyles};
  font-size: 1.2rem;

  margin: .5rem 0;
  font-weight: 400;
  letter-spacing: -0.008em;
`;

const StyledH4 = styled.h4`
  ${headerStyles};
  font-size: 1.2rem;
  font-weight: 100;
`;

const Header: React.FC<UFCTextProps> = ({srOnly, ...props}) => {
  const classes = srOnly ? 'sr-only' : '';

  return <StyledH2 className={classes} {...props} />;
};

export const H2: React.FC<UFCTextProps> = ({...props}) => {
  return <Header as={StyledH2} {...props} />;
};
export const H3: React.FC<UFCTextProps> = ({...props}) => {
  return <Header as={StyledH3} {...props} />;
};
export const H4: React.FC<UFCTextProps> = ({...props}) => {
  return <Header as={StyledH4} {...props} />;
};

export const Texto: React.FC<UFCTextProps> = ({srOnly, ...props}) => {
  const classes = srOnly ? 'sr-only' : '';

  return <StyledTexto className={classes} {...props} />;
};

const StyledTexto = styled.span`
  color: ${props => props.theme.texto.enfase_media};
`;

export const P: React.FC<UFCTextProps> = ({srOnly, ...props}) => {
  return <Texto as="p" {...props} />;
};

export const TextoPequeno = styled(StyledTexto)`
  font-size: 0.8rem;
`;
export const Negrito = styled(StyledTexto)`
  color: ${p => p.theme.texto.enfase_alta};
  font-weight: 800;
`;


export interface LoadingTextoProps {
  tipo?: "div"|"span"
  width?: number
}

export const LoadingTexto = styled.div<LoadingTextoProps>`
  ${({tipo}) => tipo === 'div' ? 'max-' : ''}width: ${p => (p.width ?? 60) + randomInt(-20, 20)}px;
  ${({tipo}) => tipo === 'span' && css`
    display: inline-block
  `};
  height: 12px;
  margin: ${Spacing.unit/4}px;
  background-color: ${({theme}) => theme.background.loading};
  border-radius: 10px;
`;

export const TextoMarkdown = styled(Markdown)`
  p {
    margin-bottom: 0.25em;
  }
`;